<div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
  <span ref="agLabel" class="ag-header-group-text mr-5" role="columnheader">{{ params.displayName }}</span>
  <span role="img"
        class="mat-icon notranslate material-icons-outlined mat-icon-no-color material-icons cursor color-grey-light color-black-hover"
        aria-hidden="true"
        data-mat-icon-type="font"
        *ngIf="!params.columnApi.isPinningLeft() && params.columnGroup.children.length > 1"
        (click)="expandOrCollapse()">{{ isExpanded && iconOpened || iconClosed }}</span>
</div>
